export var GoogleOAuthScope;
(function (GoogleOAuthScope) {
    GoogleOAuthScope["DriveReadonly"] = "https://www.googleapis.com/auth/drive.readonly";
})(GoogleOAuthScope || (GoogleOAuthScope = {}));
